import { initGraphQLTada } from 'gql.tada';
import type { introspection } from './graphql-env.d.ts';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    uuid: string;
    timestamptz: string;
    bigint: number;
    numeric: number;
    jsonb: { [key: string]: any } & { [key: string]: any }[];
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { maskFragments, readFragment } from 'gql.tada';
